import React from "react";
import { TodoContext } from "../TodoContext";

function TodoForm() {
  const { addTodo, setOpenModal } = React.useContext(TodoContext);
  const [newTodo, setNewTodo] = React.useState("");

  const onSubmit = (event) => {
    event.preventDefault();
    setOpenModal(false);
    addTodo(newTodo);
  };

  const onChange = (event) => {
    setNewTodo(event.target.value);
  };

  return (
    <form
      onSubmit={onSubmit}
      className="relative transform overflow-hidden rounded-lg bg-gray-900 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg"
    >
      <div className="dark:bg-gray-50 bg-gray-700 text-white dark:text-black px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
          <h3 className="text-base leading-6" id="modal-title">
            Escribe tu nueva tarea:
          </h3>
          <div className="mt-2">
            <input
              value={newTodo}
              onChange={onChange}
              placeholder="Hacer curso de ..."
              className="todo-search w-full my-4 p-2 bg-white text-black focus:outline-violet-500 drop-shadow-md rounded-md placeholder:text-gray-500"
            />
          </div>
        </div>
      </div>
      <div className="dark:bg-gray-50 bg-gray-700 px-4 py-3 sm:flex justify-center sm:px-6">
        <button
          type="submit"
          disabled={newTodo.length > 0 ? false : true}
          className="mt-3 inline-flex w-full justify-center rounded-md hover:bg-violet-400 bg-violet-500 px-3 py-2 text-sm text-white shadow-sm sm:mt-0 sm:w-auto disabled:opacity-50"
        >
          Guardar
        </button>
      </div>
    </form>
  );
}

export { TodoForm };
